function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import FullscreenSlider from './fullscreenSlider.js';
import FullscreenMobileBar from './FullscreenMobileBar';
import FullscreenSidebar from './fullscreenSidebar.js';
import FullscreenShareScreen from './fullscreenShareScreen.js';
import ProGallerySlider from './ProGallerySlider';
import { fixedStyles } from './proGallerySliderFixedStyles';
import MobileZoom from './MobileZoom';

var MobileExpand = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(MobileExpand, _React$Component);

  function MobileExpand(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "getCustomInfoRenderer", function (pgItemProps) {
      var style = pgItemProps.style;
      var _this$props$styles = _this.props.styles,
          allowDescriptionExpand = _this$props$styles.allowDescriptionExpand,
          allowTitleExpand = _this$props$styles.allowTitleExpand;
      var customMobileSidebarRenderer = _this.props.customMobileSidebarRenderer;
      var imageMarginTop = Math.round((style.width / style.ratio - style.height) / -2);
      console.log('item', imageMarginTop, pgItemProps);
      var galleryAlignExpand = _this.props.styles.galleryAlignExpand;
      var marginTop = imageMarginTop >= 0 ? style.height - imageMarginTop * 2 : style.height;
      var styles = {
        textAlign: galleryAlignExpand,
        marginTop: marginTop,
        height: 'fit-content'
      };
      var infoElement;

      if (typeof customMobileSidebarRenderer === 'function') {
        infoElement = /*#__PURE__*/React.createElement("div", {
          style: styles,
          className: 'pro-gallery-expand-info artstore-info'
        }, customMobileSidebarRenderer(_objectSpread(_objectSpread({}, _this.props), {}, {
          styleParams: _this.props.styles,
          item: pgItemProps
        })));
      } else {
        infoElement = /*#__PURE__*/React.createElement("div", {
          style: styles,
          className: 'pro-gallery-expand-info'
        }, allowTitleExpand && /*#__PURE__*/React.createElement("div", {
          className: 'fullscreen-side-bar-title'
        }, /*#__PURE__*/React.createElement("p", null, pgItemProps.title)), allowDescriptionExpand && /*#__PURE__*/React.createElement("div", {
          className: 'fullscreen-side-bar-description'
        }, /*#__PURE__*/React.createElement("p", null, pgItemProps.description)));
      }

      return infoElement;
    });

    _this.isExpandedView = false;
    _this.isTouchDeviceZoom = false;
    return _this;
  }

  var _proto = MobileExpand.prototype;

  _proto.getSlider = function getSlider() {
    var shouldUseProGallerySlider = this.props.shouldUseProGallerySlider;

    var props = _objectSpread(_objectSpread({}, this.props), {}, {
      isExpandedView: this.isExpandedView,
      isTouchDeviceZoom: this.isTouchDeviceZoom
    });

    if (shouldUseProGallerySlider) {
      return this.getProGallerySlider();
    }

    return /*#__PURE__*/React.createElement(FullscreenSlider, props);
  };

  _proto.getProGallerySlider = function getProGallerySlider() {
    var _this$props = this.props,
        items = _this$props.items,
        resizeMediaUrl = _this$props.resizeMediaUrl,
        totalItems = _this$props.totalItems,
        current = _this$props.current,
        actions = _this$props.actions,
        container = _this$props.container;
    var props = {
      container: container,
      items: items,
      totalItemsCount: totalItems,
      resizeMediaUrl: resizeMediaUrl,
      currentIdx: current.item.idx,
      actions: actions,
      styles: fixedStyles.mobileExpand,
      customSlideshowInfoRenderer: this.getCustomInfoRenderer
    };
    var style = {
      height: 'fit-content'
    };
    return /*#__PURE__*/React.createElement("div", {
      style: style,
      className: "pro-gallery-mobile-expand"
    }, /*#__PURE__*/React.createElement(ProGallerySlider, props));
  };

  _proto.getSideBar = function getSideBar() {
    var _this$props2 = this.props,
        shouldShowInfo = _this$props2.shouldShowInfo,
        hasAdditionalSidebarElement = _this$props2.hasAdditionalSidebarElement;

    if (!shouldShowInfo && !hasAdditionalSidebarElement) {
      return null;
    }

    return /*#__PURE__*/React.createElement(FullscreenSidebar, this.props);
  };

  _proto.getFullscreenShareScreen = function getFullscreenShareScreen() {
    return /*#__PURE__*/React.createElement(FullscreenShareScreen, this.props);
  };

  _proto.getTopMobileBar = function getTopMobileBar() {
    return /*#__PURE__*/React.createElement(FullscreenMobileBar, this.props);
  };

  _proto.getMobileZoom = function getMobileZoom() {
    var _React$createElement;

    return /*#__PURE__*/React.createElement(MobileZoom, (_React$createElement = {
      current: this.props.current,
      currentWindow: this.props.currentWindow,
      styles: this.props.styles,
      container: this.props.container,
      actions: this.props.actions,
      initialOffset: 60,
      currentGalleryItem: this.props.currentGalleryItem
    }, _React$createElement["current"] = this.props.current, _React$createElement));
  };

  _proto.render = function render() {
    var _this2 = this;

    var hasAdditionalSidebarElement = this.props.hasAdditionalSidebarElement;
    return /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref) {
        return _this2.props.setRef(_ref);
      },
      "data-hook": "fullscreen-view",
      id: "fullscreen-view",
      className: this.props.fullscreenClasses,
      role: "dialog",
      "aria-label": "Gallery item, detailed view"
    }, this.props.isMobileZoom ? this.getMobileZoom() : null, this.getTopMobileBar(), this.getSlider(), hasAdditionalSidebarElement ? this.getSideBar() : null, this.getFullscreenShareScreen());
  };

  return MobileExpand;
}(React.Component);

export default MobileExpand;